module.exports = "<div *ngIf=\"!driversPopulated\">\r\n  <span>Loading Drivers...</span>\r\n</div>\r\n<ng-select class=\"round-input\" *ngIf=\"driversPopulated\" [allowClear]=\"true\" [items]=\"driverList\" (data)=\"refreshValue($event)\" (selected)=\"selected($event)\"\r\n  (removed)=\"removed($event)\" (typed)=\"typed($event)\" placeholder=\"Assign Driver\">\r\n</ng-select>\r\n<br>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/driver-select-box/driver-select-box.component.html
// module id = ./src/app/shared/driver-select-box/driver-select-box.component.html
// module chunks = main